import { render, staticRenderFns } from "./ConfirmChangePassword.vue?vue&type=template&id=77ccb94a&scoped=true&"
import script from "./ConfirmChangePassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmChangePassword.vue?vue&type=style&index=0&id=77ccb94a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ccb94a",
  null
  
)

export default component.exports